export default "__VITE_ASSET__DyXk8lxD__"